// extracted by mini-css-extract-plugin
export var Header = "Header-module--Header--1qiY2";